import { z } from "zod";

export interface CashRequestDetail {
  id: number;
  idMovimientoBIND?: number;
  montoSolicitado: number;
  saldoActual: number;
  fechaSolicitud: string;
  cuentaOrigen: string;
  sucursal: string;
  solicitante: string;
  estado: string;
  control: boolean;

  mensajes: {
    texto: string;
    fechaHora: string;
    usuario: string;
    esUsted: boolean;
  }[];
}

export const cashRequestFilterSchema = z.object({
  request_date: z.any().optional(),
  sucursal: z.any().optional(),
  request_amount: z.any().optional(),
  requester: z.any().optional(),
  account_number: z.any().optional(),
  estados: z.any().optional(),
  balance_control: z.any().optional(),
});

export const cashRequestCreationSchema = z.object({
  account: z.any().optional(),
  account_type: z.any().optional(),
  sucursal: z.any().optional(),
  request_amount: z.any().optional(),
  request_detail: z.any().optional(),
  usuarioMobile: z.any().optional(),
});

export interface CashRequestEntity {
  id: number;
  fechaCreacion: string;
  idTipoSolicitud: number;
  tipoSolicitudDescripcion: string;
  idEstado: number;
  estadoDescripcion: string;
  titular: string;
  idSucursal: number;
  sucursalNombre: string;
  monto: number;
  usuarioCrea: string;
  control: boolean;
  estado: string;
}
